import { inject, observer } from 'mobx-react';
import * as React from 'react';
import {
  STORE_CONTACT,
  STORE_CONVERSATION,
  STORE_NOTIFICATION,
  STORE_PARTICIPANT,
  STORE_PERSON,
  STORE_PHONE_CALL,
  STORE_UI,
} from '../../constants/stores';
import withRouter from '../../hocs/WithRouter';
import { Styled } from './index.styles';
import { SuccessScreenProps } from './interfaces';

const closeBtn = require('../../assets/images/close-btn.svg');
const successIcon = require('../../assets/images/success-icon.svg');

class SuccessScreenSource extends React.Component<SuccessScreenProps> {
  closeView = () => {
    const redirectTo = '/addressBook/sources';
    this.props.navigate(redirectTo);
    this.props.person.setAddedNewSource({ show: false, sourceProvider: '' });
  };

  handleClick = () => {
    const newSource = this.props.person.allSources.find(
      (source) => source?.id === this.props.person.addedNewSource?.id
    );

    if (!newSource) {
      return;
    }

    newSource && this.props.showContactsBasedOnSource(newSource)();
    this.props.person.setAddedNewSource({ show: false, sourceProvider: '' });
  };

  render() {
    return (
      <Styled.SuccessScreen>
        <img src={successIcon} />
        {this.props.alreadyAddedMessage ? (
          <Styled.SuccessMessage>
            {this.props.alreadyAddedMessage}
          </Styled.SuccessMessage>
        ) : (
          <>
            <Styled.SuccessMessage>
              You have successfully connected new <b>{this.props.provider}</b>{' '}
              account
            </Styled.SuccessMessage>
            <Styled.WaitMessage>
              Your contacts are getting synchronised... This might take few
              minutes.
            </Styled.WaitMessage>
          </>
        )}
        <Styled.CloseButton src={closeBtn} onClick={this.closeView} />
        <Styled.ViewContactsButton
          onClick={this.handleClick}
          content={`VIEW CONTACTS`}
          primary
          className="link semantic-flex-fluid"
        />
      </Styled.SuccessScreen>
    );
  }
}
export default inject(
  STORE_PERSON,
  STORE_CONVERSATION,
  STORE_UI,
  STORE_PARTICIPANT,
  STORE_CONTACT,
  STORE_PHONE_CALL,
  STORE_NOTIFICATION
)(withRouter(observer(SuccessScreenSource)));
